import React from 'react';
import { useDeviceSize } from 'common/lib/hooks/useDeviceSize';
import { CDN_IMAGE_SRC } from 'common/lib/helpers/constants';
import PropTypes from 'prop-types';
import { Box } from '@fabric-ds/react';
import * as S from './styles';

const RedirectBanner = ({ finnkodeNextAd, podletPath }) => {
    const { isMobile } = useDeviceSize();

    const goToAd = () => {
        window.location.href = `${podletPath}?finnkode=${finnkodeNextAd}`;
    };

    const icon = (
        <img
            className="mr-16"
            src={`${CDN_IMAGE_SRC}/illustrations/profile.svg`}
            height={100}
            width={100}
            alt="Profil illustrasjon"
        />
    );

    const text = (
        <S.Col>
            <p className="font-bold">Dette prosjektet har en ny annonse!</p>
            <p>
                Prosjektet er nå i en ny fase, og har fått en ny og oppdatert annonse. <br />
                Informasjonen i denne annonsen kan være utdatert.
            </p>
        </S.Col>
    );

    return (
        <Box info className="my-16 p-32">
            {isMobile ? (
                <S.Col>
                    <S.Row>
                        {icon}
                        {text}
                    </S.Row>
                    <S.Button className="button button--cta mt-16" onClick={goToAd} type="button">
                        Gå til oppdatert annonse
                    </S.Button>
                </S.Col>
            ) : (
                <S.Row>
                    {icon}
                    {text}
                    <S.Button className="button button--cta ml-16" onClick={goToAd} type="button">
                        Gå til oppdatert annonse
                    </S.Button>
                </S.Row>
            )}
        </Box>
    );
};

RedirectBanner.propTypes = {
    finnkodeNextAd: PropTypes.number.isRequired,
    podletPath: PropTypes.string.isRequired,
};

export default RedirectBanner;
